import React, { useState } from 'react';
import { Mail, Phone, MapPin, Clock, Send } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, formData);
      toast.success('Message envoyé avec succès ! Nous vous répondrons rapidement.');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de l\'envoi du message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ fontFamily: 'IBM Plex Sans' }}>
            Contactez-nous
          </h1>
          <p className="text-lg text-muted-foreground">
            Notre équipe est à votre écoute pour vous accompagner dans vos projets
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div className="lg:col-span-1 space-y-4">
            <div className="bg-white border border-border rounded-sm p-6">
              <Mail className="w-8 h-8 text-brand-orange mb-3" />
              <h3 className="font-bold mb-2">Email</h3>
              <a href="mailto:contact@batiprodeal.com" className="text-sm text-muted-foreground hover:text-brand-orange">
                contact@batiprodeal.com
              </a>
            </div>
            <div className="bg-white border border-border rounded-sm p-6">
              <Phone className="w-8 h-8 text-brand-orange mb-3" />
              <h3 className="font-bold mb-2">Téléphone</h3>
              <a href="tel:+33123456789" className="text-sm text-muted-foreground hover:text-brand-orange">
                +33 1 23 45 67 89
              </a>
            </div>
            <div className="bg-white border border-border rounded-sm p-6">
              <MapPin className="w-8 h-8 text-brand-orange mb-3" />
              <h3 className="font-bold mb-2">Adresse</h3>
              <p className="text-sm text-muted-foreground">
                BATIPRODEAL
                <br />
                France
              </p>
            </div>
            <div className="bg-white border border-border rounded-sm p-6">
              <Clock className="w-8 h-8 text-brand-orange mb-3" />
              <h3 className="font-bold mb-2">Horaires</h3>
              <p className="text-sm text-muted-foreground">
                Lun - Ven : 9h - 18h
                <br />
                Samedi : 9h - 16h
              </p>
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-2">
            <form onSubmit={handleSubmit} className="bg-white border border-border rounded-sm p-8">
              <h2 className="text-2xl font-bold mb-6" style={{ fontFamily: 'IBM Plex Sans' }}>
                Envoyez-nous un message
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium mb-1">Nom complet *</label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-border rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
                    data-testid="contact-name-input"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Email *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-border rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
                    data-testid="contact-email-input"
                  />
                </div>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Sujet *</label>
                <input
                  type="text"
                  name="subject"
                  required
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-border rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  data-testid="contact-subject-input"
                />
              </div>
              <div className="mb-6">
                <label className="block text-sm font-medium mb-1">Message *</label>
                <textarea
                  name="message"
                  required
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-border rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  data-testid="contact-message-input"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="btn-primary px-6 py-3 rounded-sm font-semibold flex items-center gap-2 disabled:opacity-50"
                data-testid="contact-submit-button"
              >
                <Send className="w-4 h-4" />
                {loading ? 'Envoi...' : 'Envoyer le message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
